import {getCommunicationStatus, getState, postCommunicationState, postState} from "./state";
import _ from "lodash";

export const getPhones = () => {
    return getCommunicationStatus().then(
        (res) => {
            const data = _.get(res, 'data', {});
            return _.get(data, 'state.desired.phones', _.get(data, 'state.reported.phones', {}));
        }
    )
}

export const getEmails = () => {
    return getCommunicationStatus().then(
        (res) => {
            const data = _.get(res, 'data', {});
            const emails = _.get(data, 'state.desired.emails', _.get(data, 'state.reported.emails', {}));
            const adminEmail = _.get(data, 'state.desired.mainEmail', _.get(data, 'state.reported.mainEmail', {}));
            return {
                emails,
                adminEmail
            }
        }
    )
}

export const getModbus = () => {
    return getState('ModbusSettingsId').then(
        (res) => {
            const data = _.get(res, 'data', {});
            return getModubsObject(_.get(data, 'state.desired.ModbusSettingsId', _.get(data, 'state.reported.ModbusSettingsId', {})));
        }
    )
}

export const updateModbus = (data: any) => {
    return postState(getModbusObjectToSend(data), 'ModbusSettingsId');
}
export const postCommunicationStatus = (data: any) => {
    return postCommunicationState(data);
}

const getModubsObject = (data: any) => {
    return {
        address: _.get(data, 'adress', ''),
        dataRate: _.get(data, 'dataRate', 0),
        dataBits: _.get(data, 'databits', 0),
        parity: _.get(data, 'parity', false),
        stopBits: _.get(data, 'stopbits', 0),
        active: _.get(data, 'Active', false)
    }
}

const getModbusObjectToSend = (data: any) => {
    return {
        'ModbusSettingsId': {
            adress: parseInt(_.get(data, 'address', ''), 10),
            dataRate: _.get(data, 'dataRate', 0),
            databits: _.get(data, 'dataBits', 0),
            parity: _.get(data, 'parity', false),
            stopbits: _.get(data, 'stopBits', 0),
            Active: _.get(data, 'active', false)
        }
    }
}
